import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { t } from 'i18next';
import { AlertAdapter } from 'pg-ui-library';

import SignupService from 'src/services/signup.service';

export const userCreateExternalUser = (): UseMutationResult<
  any,
  Error,
  { user: { email: string; companies: string[] } },
  void
> =>
  useMutation(({ user }: { user: { email: string; companies: string[] } }) => SignupService.signupExternalUser(user), {
    onSuccess: () => {
      AlertAdapter(t('settings.externalUsers.text1'), 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const userDeleteExternalUser = (): UseMutationResult<any, Error, string, void> =>
  useMutation(email => SignupService.deleteExternalUser(email), {
    onSuccess: () => {
      AlertAdapter(t('settings.externalUsers.text4'), 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const userCreateExternaClientlUser = (): UseMutationResult<
  any,
  Error,
  { user: { email: string; companies: string[] } },
  void
> =>
  useMutation(({ user }: { user: { email: string; companies: string[] } }) => SignupService.signupExternalUser(user), {
    onSuccess: () => {
      AlertAdapter(t('settings.externalUsers.text1'), 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useCreateExternalClientUser = (): UseMutationResult<any, Error, any, void> =>
  useMutation((payload: any) => SignupService.signupExternalClientUser(payload), {
    onSuccess: () => {
      AlertAdapter(t('settings.externalUsers.text1'), 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useUploadExternalClientUsers = (): UseMutationResult<any, Error, File, void> =>
  useMutation((file: File) => SignupService.uploadExternalClientUsers(file), {
    onSuccess: () => {
      AlertAdapter(t('settings.externalUsers.uploadSuccess'), 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
